import React from 'react';
import styled from 'styled-components';

import SelectSocialIcon from '../../UI/Img/SocialIcons';

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  max-width: 60px;
  flex: 1 0 100px;
  > svg {
    padding: 0;
  }
  :focus {
    outline: none;
  }
`;

export const HeaderSocial = props => (
  <SocialLink href={props.link} target="_blank">
    <SelectSocialIcon iconName={props.icon} origin="header menu" />
  </SocialLink>
);

export default HeaderSocial;



// WEBPACK FOOTER //
// ./src/components/Index/Header/HeaderSocial.jsx